import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    // The imported size guide is itself the horizontal scroll container.
    if (table.id === 'size-guide') {
      table.tabIndex = 0;
      if (!table.hasAttribute('aria-label')) table.setAttribute('aria-label', 'Size guide');
    }
    // Section reconnection should not nest redundant scroll wrappers.
    if (table.parentElement?.classList.contains('rte-table-wrapper')) return;
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
